import classNames from "classnames"

import "./Link.scss"

type TVariant = "normal" | "high-contrast"
type TSize = "xl" | "lg" | "md" | "sm" | "xs"

interface ILink {
  /** URL do link */
  href: string
  /** Texto de label*/
  label?: string
  /** Para conteúdo customizado */
  children?: any
  /** Classes para customização */
  className?: string
  /**
   * Estilo do link.
   * - normal =  Link normal activo.
   * - high-contrast = Serve para o ativar o estilo de alto contrast.
   */
  variant?: TVariant
  /** tamanhos para customização */
  size?: TSize
}

const Link = ({
  label,
  href,
  className,
  children,
  variant = "normal",
  size = "md",
  ...props
}: ILink) => {
  const linkClass = classNames(
    "ds-link",
    className,
    `ds-link--${size.toLowerCase()}`,
    {
      [`ds-link--${variant}`]: !!variant,
    }
  )

  return (
    <a className={linkClass} href={href} {...props}>
      {label || children}
    </a>
  )
}

export default Link
